"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncScoreStatus = void 0;
/**
 * It contains information about the assessment
 *
 * @property {resourceId}                id                          - identifier for the assessment
 * @property {number}                contextId                       - the user owning this assessment. The user who assigned the template
 * @property {number}    title          - associated assessment template
 *
 * @author anoop.sharma
 */
var SyncScoreStatus = /** @class */ (function () {
    function SyncScoreStatus(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    return SyncScoreStatus;
}());
exports.SyncScoreStatus = SyncScoreStatus;
